<template>
<div class="tools-bar-container">
    <div id="ip-tools-bar-id" class="buttons">
      <moo-tooltip effect="dark" :content="$t('上一张#!!!#src/pages/H5/Cloud/components/imagepreview/components/toolsbar.vue_1')" placement="top">
        <button :disabled="!canPrev" @click="$emit('prev')">
          <CloudArrowLeft></CloudArrowLeft>
        </button>
      </moo-tooltip>
      <moo-tooltip effect="dark" :content="$t('下一张#!!!#src/pages/H5/Cloud/components/imagepreview/components/toolsbar.vue_1')" placement="top">
        <button :disabled="!canNext" @click="$emit('next')">
          <CloudArrowRight></CloudArrowRight>
        </button>
      </moo-tooltip>

      <div class="divide"></div>

      <moo-tooltip effect="dark" :content="$t('缩小#!!!#src/pages/H5/Cloud/components/imagepreview/components/toolsbar.vue_1')" placement="top">
        <button :disabled="zoomInDisabled" @click="onZoomIn">
          <CloudPreviewZoomIn></CloudPreviewZoomIn>
        </button>
      </moo-tooltip>
      <moo-tooltip effect="dark" :content="$t('放大#!!!#src/pages/H5/Cloud/components/imagepreview/components/toolsbar.vue_1')" placement="top">
        <button :disabled="zoomOutDisabled" @click="onZoomOut">
          <CloudPreviewZoomOut></CloudPreviewZoomOut>
        </button>
      </moo-tooltip>

      <div class="divide"></div>

      <moo-tooltip effect="dark" :content="$t('旋转#!!!#src/pages/H5/Cloud/components/imagepreview/components/toolsbar.vue_1')" placement="top">
        <button @click="onRotate">
          <CloudPreviewRotate></CloudPreviewRotate>
        </button>
      </moo-tooltip>
      <moo-tooltip effect="dark" :content="$t('下载#!!!#src/pages/H5/Cloud/components/imagepreview/components/toolsbar.vue_1')" placement="top">
        <button v-if="!downloadDisabled" @click="$emit('download')">
          <CloudPreviewDownload></CloudPreviewDownload>
        </button>
      </moo-tooltip>
    </div>
  </div>
</template>

<script>
import CloudArrowLeft from "../icons/cloud-arrow-left-v1.vue";
import CloudArrowRight from "../icons/cloud-arrow-right-v1.vue";
import CloudPreviewDownload from "../icons/cloud-preview-download-v1.vue";
import CloudPreviewRotate from "../icons/cloud-preview-roate-v1.vue";
import CloudPreviewZoomIn from "../icons/cloud-preview-zoom-in-v1.vue";
import CloudPreviewZoomOut from "../icons/cloud-preview-zoom-out-v1.vue";

export default {
  components: {
    CloudArrowLeft,
    CloudArrowRight,
    CloudPreviewDownload,
    CloudPreviewRotate,
    CloudPreviewZoomIn,
    CloudPreviewZoomOut,
  },
  props: {
    imgSrc: {
      type: String,
      default: "",
    },
    canNext: {
      type: Boolean,
      default: false,
    },
    canPrev: {
      type: Boolean,
      default: false,
    },
    canDownload: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    zoomPercent: {
      type: Number,
      default: 1,
    },
    imgRotate: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    imgSrc: {
      handler() {
        this.percent = 1;
        this.rotate = 0;
        this.$emit("before-load");
      },
      immediate: true,
    },
    zoomPercent(val) {
      this.percent = val;
    },
    imgRotate(val) {
      this.rotate = val;
    },
  },
  data() {
    return {
      percent: 1,
      rotate: 0,
      timer: null,
    };
  },
  methods: {
    onZoomOut() {
      if (this.zoomOutDisabled) return;
      this.$emit("zoom-out");
    },
    onZoomIn() {
      if (this.zoomInDisabled) return;
      this.$emit("zoom-in");
    },
    onRotate() {
      this.$emit("rotate");
    },
  },
  computed: {
    zoomInDisabled() {
      return this.percent <= 0.2;
    },
    zoomOutDisabled() {
      return this.percent >= 2;
    },
    downloadDisabled() {
      return !this.canDownload;
    },
  },
};
</script>

<style lang="scss" scoped>
.tools-bar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  box-sizing: border-box;

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 48px;
    padding: 0 12px;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 6px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      padding: 2px;
      user-select: none;
      background: transparent;
      border: none;
      border-radius: 4px;
      outline: none;

      svg {
        width: 20px;
        height: 20px;
        color: #fff;
        fill: currentColor;
      }

      &:hover {
        background-color: rgba(255, 255, 255, 0.3);
        cursor: pointer;
      }

      &:disabled {
        background-color: transparent;
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    button + button {
      margin-left: 14px;
    }

    .divide {
      width: 1px;
      height: 16px;
      margin: 0 12px;
      background: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>
